export const translations = {
  locale: 'en',
  direction: 'ltr',
  text: {
    loginStageOneLink: 'Use Custom Domain',
    loginStageTwoForgotPassword: 'Forgot Password?',
    footerText:
      'Copyright © 2005-2023 NiCE LTD | inContact, Inc. All Rights Reserved.',
    welcomeToAgeOfAI: 'Welcome to the Age of AI for CX',
    ourServices:
      'We have purpose-built AI solutions that are transforming businesses.',
    webinarsDescription1: `Our 5-part on-demand webinar series featuring leading AI experts
              will showcase why CX-built AI will revolutionize how your
              customers, employees, and executives interact with your brand.`,
    webinarsDescription2: `Our
              webinars address a critical business stakeholder's specific
              challenge and provide actionable strategies for deploying AI
              focused on the customer experience. These webinar sessions are
              ready to help you transform your CX through the power of AI`,
    footerTextLink: 'Contact Us',
    contactCardAddress: 'Address',
    contactCardHistory: 'Contact History',
    agentMessages: 'Conversations',
    viewMore: 'View {x} More',
    assignments: 'Inbox',
    noAssignments: 'No Assignments',
    accept: 'Accept',
    reject: 'Reject',
    markAsResolved: 'Mark As Resolved',
    save: 'Save',
    dockControls: 'Dock Controls',
    pinControls: 'Pin Controls',
    addChannel: 'Add Channel',
    hold: 'Hold',
    resume: 'Resume',
    mute: 'Mute',
    unmute: 'Unmute',
    mask: 'Mask',
    unmask: 'Unmask',
    end: 'End',
    recording: 'Recording',
    transfer: 'Consult/Transfer',
    transferContact: 'Transfer',
    commit: 'Commit',
    consult: 'Consult',
    hungup: 'Hang Up',
    record: 'Record',
    keypad: 'Keypad',
    contactControls: 'Contact Controls',
    goAvailable: 'Go Available',
    searchAgentStatus: 'Search agent status',
    myProfile: 'My Profile',
    favorites: 'Favorites',
    allCodesX: 'All Codes ({x})',
    logOut: 'Log Out',
    participantX: 'Participants ({x})',
    waitingOnHold: 'Waiting on Hold',
    inConsult: 'In Consult',
    Ringing: 'Ringing',
    Conference: 'Conference',
    Consult: 'Consult',
    agentSearchBox: 'Search for people, skills, teams, etc.',
    available: 'Available',
    unavailable: 'Unavailable',
    working: 'Working',
    noAgentFound: 'No Agent(s) Found.',
    myTeam: 'My Team',
    appSpace: 'App Space',
    contactCard: 'Contact Card',
    schedule: 'Schedule',
    calendar: 'Calendar',
    directory: 'Directory',
    sentiment: 'Sentiment',
    enlighten: 'Enlighten',
    wem: 'WEM',
    quickReply: 'Quick Replies',
    account: 'Account',
    home: 'Home',
    assignment: 'Assignment',
    queue: 'Queue',
    appHealth: 'App Health',
    settings: 'Settings',
    entry: 'Entry',
    entries: 'Entries',
    hide: 'Hide',
    hideAllDetails: 'Hide All Details',
    hidden: 'Hidden',
    unhide: 'Unhide',
    delete: 'Delete',
    sessions: 'Sessions',
    search: 'Search',
    all: 'All',
    overall: 'Overall',
    inbound: 'Inbound',
    outbound: 'Outbound',
    addEdit: 'Add / Edit',
    viewLess: 'View Less',
    channels: 'Channels',
    cellphone: 'Cell Phone',
    whatsapp: 'Whatsapp',
    twitter: 'Twitter',
    minimizePanel: 'Minimize Panel',
    newBrowserWindow: 'Make new browser window',
    rtaActiveTooltipMessage:
      "Analyzing the Patron's voice and comparing to their enrolled voiceprint.",
    rtaAuthenticatedTooltipMessage:
      "The Patron's identity was successfully authenticated by using CXone RTA.",
    rtaNotAuthenticatedTooltipMessage:
      "The Patron's identity was not authenticated by using CXone RTA.",
    rtaMissingPatronIdTooltipMessage: 'ID for the Patron is required for RTA.',
    rtaListeningStatus: 'Listening to Patron ID',
    rtaDialogTitle: 'RTA Enrollment',
    enroll: 'Enroll',
    cancel: 'Cancel',
    discard: 'Discard',
    launch: 'Launch',
    controlPosition: 'Control Position',
    sms: 'SMS',
    email: 'Email',
    addNewChannel: 'Add New Channel',
    outcomes: 'Outcomes',
    allQuickReplies: 'All Quick Replies',
    publicTweet: 'Public Tweet',
    age: 'Age',
    timezone: 'Timezone',
    companySize: 'Company Size',
    replyingTo: 'Replying to',
    viewDetails: 'View Details',
    hideDetails: 'Hide Details',
    viewOriginalTweet: 'View Original Tweet',
    hideOriginalTweet: 'Hide Original Tweet',
    viewRepliesTweet: 'View Replies to Tweet',
    hideRepliesTweet: 'Hide Replies to Tweet',
    callRejected: 'Call Rejected',
    digitalInteractionRejected: 'Rejected',
    requestInteraction: 'Request Interaction',
    newOutbound: 'New Outbound',
    requestingInteraction: 'Requesting Interaction',
    quickChatPlaceHolder: 'Enter Message Here',
    conversations: 'Conversations',
    noMatchesFound: 'No Matches Found',
    addSms: 'Add SMS',
    addEmail: 'Add Email',
    back: 'Back',
    reloadApplication: 'Reload Application',
    agentName: 'Agent Name',
    agentId: 'Agent Id',
    stationId: 'Station Id',
    phoneNumber: 'Phone Number',
    callerId: 'Caller Id',
    browserVersion: 'Browser Version',
    browserLanguage: 'Browser Language',
    currentContacts: 'Current Contacts',
    displayedUsername: 'Displayed Username',
    version: 'Version',
    sessionId: 'Session Id',
    agentLegId: 'Agent Leg Id',
    agentLeg: 'Agent Leg',
    webServer: 'Web Server',
    virtualCluster: 'Virtual Cluster',
    browserLocalization: 'Browser Localization',
    currentTimezone: 'Current Time & Timezone',
    contactLimit: 'Contact Limit',
    totalLimit: 'Total Limit',
    reqContact: 'Request Contact',
    contactAutoFocus: 'Contact Auto Focus',
    teamName: 'Team Name',
    routing: 'Routing',
    enabled: 'Enabled',
    disabled: 'Disabled',
    viewOriginalPost: 'View Original Post',
    hideOriginalPost: 'Hide Original Post',
    viewRepliesPost: 'View Replies to Post',
    hideRepliesPost: 'Hide Replies to Post',
    publicComment: 'Public Comment',
    next: 'Next',
    welcomeHeaderText: 'Welcome',
    signInToYourAccountText: 'Sign in to your account',
    enterYourUsernameLabel: 'Enter your Username',
    enterYourPasswordTitle: 'Enter your password',
    continueButtonText: 'Continue',
    passwordErrorMessage: 'Please check your details and try again',
    checkYourEmailTitle: 'Check your email',
    checkYourEmailSubtitle:
      'We sent you an email with a link to reset your password.',
    backToSignInButtonText: 'Back to sign in',
    resendEmailButtonText: 'Resend email',
    lyraFooterCopyright: '© 2005-2026 NiCE LTD. All Rights Reserved.',
    signInHeader: 'Sign in to CXone',
    userName: 'Username',
    password: 'Password',
    backButtonText: 'Back',
    signInButtonText: 'Sign In',
    rememberMe: 'Remember Me',
    voicePreferences: 'Voice Preferences',
    voiceConnection: 'Voice Connection',
    rememberPreference: 'Remember Preference',
    viewAll: 'View All',
    viewAllDetails: 'View All Details',
    favorties: 'Favorites',
    confirmationNumber: 'Confirmation Number',
    allQReplies: 'All Quick Replies',
    replyToPreviousComment: 'This a reply to a previous comment',
    loginAndVoicePreference: 'Login & Voice Preferences',
    avNotifications: 'A/V Notifications',
    displayAndAccessability: 'Display & Accessibility',
    displayAndKeyboard: 'Display & Keyboard',
    reportIssue: 'Report Issue',
    favortie: 'Favourite',
    notFavorite: 'Not Favourite',
    notifications: 'Notifications',
    screenPop: 'Screen Pop',
    invalidPhoneNumber: 'Invalid Phone Number',
    invalidStationId: 'Invalid Station ID',
    agentStateUpNext: 'Up Next',
    agentStateNextNext: 'After That',
    cxoneAgentAvailable:
      'CXone Agent is only available for business units using Omnichannel Session Handling (OSH) routing and User Hub administration.',
    voicePermissionUnavailable:
      'Unable to login. This user does not have permissions for any voice connection options.',
    logIn: 'Log In',
    backToLogin: 'Back to Login',
    inboundContact: 'Inbound Contact',
    outboundContact: 'Outbound Contact',
    inboundConsult: 'Inbound Consult',
    outboundConsult: 'Outbound Consult',
    dialer: 'Dialer',
    dialerPending: 'Dialer Pending',
    loggedOut: 'Logged Out',
    agentLegConnected: 'Agent leg connected.',
    agentLegDisconnected: 'Agent leg disconnected.',
    agentLegDialing: 'Agent leg dialing.',
    clickToConnect: 'Click to connect.',
    clickToDisconnect: 'Click to disconnect.',
    skills: 'Skills',
    skillQueue: 'Queue',
    skillWait: 'Wait',
    includeExternalDir: 'Include external directories',
    externalDirectorylabel: 'External Directories',
    on: 'On',
    off: 'Off',
    invalidAgentid: 'Invalid Agent Id.',
    phoneNumberInUseGeneric:
      'The phone number you entered is already in use.  You must enter a different phone number.',
    phoneNumberInUse:
      'The phone number is currently in use by another agent. Try again later or use a different phone number.',
    stationIdInUseGeneric:
      'The Station ID you entered is already in use.  You must enter a different Station ID.',
    stationIdInUse:
      'The Station ID is currently in use by another agent. Try again later or use a different Station ID.',
    phoneNumberInUseLessThanSevenDigits:
      'Please enter your full phone number, including extension, if applicable.',
    agentOrStationLimitExceeded:
      'Concurrent agent limit or station limit exceeded.',
    unauthorized: 'Unauthorized',
    insufficientPermissions: 'Insufficinet Permissions',
    sessionInProgress: 'Session in Progress',
    invalidSessionTimeout:
      'Invalid session timeout value.  Timeout value must be 30 to 300, or 0 for default.',
    stationLimitExceeded: 'Station Limit Exceeded',
    minutes: 'min',
    setPhoneNumber: 'Set Phone Number',
    setStationID: 'Set Station ID',
    stationID: 'Station ID',
    integratedSoftPhone: 'Integrated Softphone',
    microsoftAcs: 'Microsoft ACS',
    teams: 'Teams',
    members: 'members',
    voiceCall: 'Voice Call',
    close: 'Close',
    contactHistory: 'Contact History',
    customerCard: 'Customer Card',
    call: 'Call',
    loading: 'Loading',
    loadMore: 'load more...',
    subject: 'Subject',
    damagedLuggageClaim: 'Damaged Luggage Claim',
    searchResults: 'Search Results',
    frequentlyUsed: 'Frequently Used',
    smileysAndEmotions: 'Smileys & Emotion',
    peopleAndBody: 'People & Body',
    animalAndNature: 'Animals & Nature',
    foodAndDrink: 'Food & Drink',
    activity: 'Activity',
    travelAndPlaces: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    noEmojiFound: 'No Emoji Found',
    defaultSkinTone: 'Default skin tone',
    lightSkinTone: 'Light skin tone',
    mediumLightSkinTone: 'Medium light skin tone',
    mediumSkinTone: 'Medium skin tone',
    mediumDarkSkinTone: 'Medium dark skin tone',
    darkSkinTone: 'Dark skin tone',
    chat: 'Webchat',
    messages: 'Messages',
    li: 'LinkedIn',
    fb: 'Facebook',
    telegram: 'Telegram',
    Insta: 'Instagram',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
    Chat: 'Chat',
    Email: 'Email',
    tw: 'Twitter',
    yt: 'YouTube',
    interaction: 'Interaction',
    completed: 'completed',
    week: 'Week',
    day: 'Day',
    mySchedule: 'My Schedule',
    ShiftBidding: 'Shift Bidding',
    ScheduleRequests: 'Schedule Requests',
    Evaluations: 'Evaluations',
    CoachingSessions: 'Coaching Sessions',
    RequestCoaching: 'Request Coaching',
    acknowledge: 'Acknowledge',
    attachments: 'Attachments',
    resources: 'Resources',
    CoachingRequests: 'Coaching Requests',
    RecentInteractions: 'Recent Interactions',
    private: 'Private',
    more: 'More',
    forward: 'Forward',
    replyAll: 'Reply All',
    agents: 'Agents',
    from: 'From',
    to: 'To',
    invalidEmailAddress: 'Invalid Email Address',
    contactCardDetails: 'Details',
    outcome: 'Outcome',
    mediaDeviceAccessDenied:
      'Application access to the media device such as headset, microphone or speaker is denied.',
    mediaDeviceAccessDeniedSubMsg:
      'Click the blocked icon in your browser address bar and select Always allow access to microphone',
    error: 'Error',
    leaveConference: 'Leave Conference',
    logOutConfirmationTitle: 'Log out Confirmation',
    logOutConfonfirmationMsg: 'Are you sure you want to log out?',
    emailToolTip: 'Enter valid Email Address here',
    textToolTip: 'Enter text here',
    noInformationAvailable: 'No information Available',
    allowMicrophonePermissionInstruction:
      "Click the blocked icon in your browser address bar and select 'Always allow access to microphone'",
    bcc: 'BCC',
    cc: 'CC',
    mark: 'Mark',
    as: 'As',
    conference: 'Conference',
    calender: 'Calender',
    send: 'Send',
    preview: 'Preview',
    today: 'Today',
    open: 'Open',
    closed: 'Closed',
    selectedinteractionswillhavetheirstatus:
      'selected interactions will have their status ',
    selectedinteractionstatushasbeenchangeto:
      'Selected interaction status has been change to ',
    customizedreplymessage:
      'Customized reply message has been sent to selected interactions.',
    statusChangeToastMsg: 'Selected interaction has been assigned to',
    importToasterMsg: 'Selected interaction has been export in CSV format.',
    interactionStatusChangeNote1:
      'The selected interactions will have this reply message sent to them. You’ll be assigned any ',
    interactionStatusChangeNote2:
      'interactions. And a new interaction will be created for any ',
    resolved: 'Resolved',
    unassign: 'Unassign & Dismiss',
    showOrigin: 'Show origin',
    notificationCount: 'You have {0} New Notification(s)',
    noNewNotification: 'No New Notifications',
    autoAccept: 'Auto Accept',
    clientSettingsTabs: 'client settings tabs',
    delaySeconds: 'Delay Seconds',
    display: 'Display',
    endLiveContact: 'End Live Contact',
    newAgentMessage: 'New Agent Message',
    newContact: 'New Contact',
    audioNotifications: 'Audio Notifications',
    visualNotifications: 'Visual Notifications',
    visualEndContact: 'End Chat or Contact',
    newContactReply: 'New Contact Reply',
    endChatOrCall: 'End Chat or Call',
    notification: 'Notification',
    playRingtone: 'Play Ringtone',
    ringTone: 'Ringtone',
    secondaryDevice: 'Secondary Device',
    secondaryRinger: 'Secondary Ringer',
    softPhone: 'Softphone',
    twentyFourHourTime: '24 hour time',
    enableLyraDesign: 'Enable Lyra Design',
    voice: 'Voice',
    Voice: 'Voice',
    Voicemail: 'Voice Mail',
    VideoCall: 'Video Call',
    ccfCustomerCardinputHelperText: 'invalid %s',
    dnis: 'DNIS',
    skillname: 'SKILL NAME',
    badNumberCalledErrorText: 'Dialed number is invalid',
    recipient: 'Recipient',
    message: 'Message',
    pastTimeStamp: 'ago',
    closedInteraction: 'You are viewing a closed interaction',
    clear: 'Clear',
    ig: 'Instagram',
    insert: 'Insert',
    fwd: 'Fwd',
    re: 'Re',
    avatar: 'Avatar',
    emptyHelperText: 'Empty/Invalid %s',
    noRecordsFound: 'No Records Found',
    loadingIndicator: 'Loading data... Please wait',
    edit: 'Edit',
    longestWait: 'LONGEST WAIT',
    skillDetails: 'Skill Details',
    activeQueue: 'Active Queue',
    contacts: 'CONTACTS',
    channel: 'CHANNEL',
    wait: 'WAIT',
    agentsAssigned: 'AGENTS ASSIGNED',
    channelTypes: 'CHANNEL TYPES',
    totalContacts: 'TOTAL CONTACTS',
    caseStatusChanged: 'Case status changed to {x} successfully',
    unableToChangeCaseStatus: 'Unable to change case status #{x}',
    unableToUnassignCase: 'Unable to unassign case #{x}',
    caseUnassigned: 'Case - {x} unassigned successfully',
    fileSize40Mb: 'File size exceeded than allowed limit of 40MB',
    fileSize0Mb: '0 byte file size, not allowed to upload',
    newMessage: 'New Message',
    skillSelect: 'Select a skill',
    channelSelect: 'Select a channel',
    ignore: 'Ignore',
    Post: 'Post',
    tweet: 'Tweet',
    chatContactMode: 'Chat',
    mail: 'Mail',
    smsContactMode: 'Sms',
    activeContactsInQueue:
      'You currently have active contacts. Are you sure you want to log out?',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    bulletedList: 'Bulleted List',
    numberedList: 'Numbered List',
    leftAlign: 'Left Align',
    rightAlign: 'Right Align',
    centerAlign: 'Center Align',
    clearReply: 'Clear drafted reply',
    discardReply: 'Discard drafted reply',
    addAttachment: 'Attach files',
    addEmoji: 'Emoji',
    unableToTransferDigitalSkill: 'Unable to transfer digital skill',
    unableToTransferDigitalContact: 'Unable to transfer digital contact',
    outboundReplyError: 'Unable to send reply/outbound: {x}',
    outboundReplyGenericError: 'Unable to send reply/outbound',
    genericErrorMsg: 'Error. Unable to complete search.',
    startAnotherInteraction: 'Start Another Interaction',
    inboundVoice: 'Inbound Voice',
    outboundVoice: 'Outbound Voice',
    wemDirectedToNewWindow:
      'You have been directed to WEM on a separate window. If you do not see a separate window, please check either your pop-up blocker or click',
    searchDirectoryPlaceHolder:
      'Search Directory or press Enter for all results',
    download: 'Download',
    downloadInfo: 'Download started successfully',
    downloadError: 'Unable to download/preview attachment',
    removeLink: 'Remove link',
    addLink: 'Add link',
    exampleEmail: 'http://www.example.com',
    transferDigitalSkill: 'Digital skill transferred successfully',
    transferDigitalContact: 'Digital contact transferred successfully',
    queueCounter: 'Queue Counter',
    here: 'here',
    new: 'New',
    add: 'Add',
    view: 'View',
    escalated: 'Escalated',
    pending: 'Pending',
    consultMessage:
      'You are already in call with agent. Cannot add another call.',
    backgroundColor: 'Highlight Color',
    textColor: 'Text Color',
    resetColor: 'Reset Color',
    resetHighlight: 'Reset Highlight',
    notes: 'Notes',
    enterNotes: 'Enter Notes',
    disposition: 'Disposition',
    status: 'Status',
    tags: 'Tags',
    networkFailure: 'Network error. Attempting to reconnect.',
    restart: 'Restart',
    dispositionSaved: 'Disposition saved Successfully.',
    unableToSaveDisposition: 'Unable to save Disposition.',
    line: 'Line',
    wechat: 'WeChat',
    microsoftteams: 'MS Teams',
    slack: 'Slack',
    viber: 'Viber',
    applebusinesschat: 'Apple Business Chat',
    time: 'Time',
    phone: 'Phone',
    addCommitments: 'Add Commitment',
    customer: 'Customer',
    firstName: 'First Name',
    lastName: 'Last Name',
    contactInformation: 'Contact Information',
    commitment: 'Commitment',
    other: 'Other',
    like: 'Like',
    selected: 'Selected',
    reactionError: 'Unable to send selected reaction',
    messageDeleted: 'Deleted',
    help: 'Help',
    openHelpCenterInNewWindow: 'Open help center in new window',
    hideUnhideError: 'Unable to hide/unhide message',
    Starttypingtofindthing: 'Start typing to find thing',
    ccfActivityId: 'ID:',
    ccfActivityPriority: 'Priority:',
    ccfActivityAssignedTo: 'Assigned To:',
    ccfActivitySearch: 'Search',
    deleteError: 'Unable to delete message',
    messageDeleteSuccess: 'Message Deleted Successfully',
    mobile: 'Mobile',
    externalDirectories: 'External Directories',
    comments: 'Comments',
    replies: 'Replies',
    goBack: 'Go back',
    addNotes: 'Add Notes',
    skill: 'Skill',
    agent: 'Agent (Me)',
    share: 'Share',
    retweet: 'Re-Tweet',
    contactCardMerged: 'Contact Card Merged',
    searchContacts: 'Search for Contacts',
    voicemail: 'Voicemail',
    inboundCall: 'Inbound Call',
    fnameErrorMessage: 'Please enter first name',
    lnameErrorMessage: 'Please enter last name',
    dateTimeErrorMessage: 'Please select a future date/time',
    phoneErrorMessage: 'Please enter a valid number',
    editCommitment: 'Edit Commitment',
    timeZone: 'Time Zone',
    networkstatus: 'Network Status',
    remove: 'Remove',
    keep: 'Keep',
    removeCommitmentConfirmationTitle: 'Remove Commitment',
    removeCommitmentConfirmationMsg:
      'Are you sure you want to remove this commitment?',
    screenPopFocusOnWindow: 'To open this page in another browser/tab, click',
    hidePublicMessageSuccess: 'Message Hidden Successfully',
    unhidePublicMessageSuccess: 'Message is no longer hidden',
    hideMessageError: 'Unable to hide message',
    unHideMessageError: 'Unable to unhide message',
    edited: 'edited',
    callback: 'Callback',
    rewind: 'Rewind',
    replay: 'Replay',
    viewMoreMessages: 'View more messages',
    noteDeleted: 'Note deleted',
    reply: 'Reply',
    helperTextMessageForNotes: 'Notes are required',
    deleted: 'Deleted',
    pause: 'Pause',
    pendingApproval: 'Pending Approval',
    editApprovalRequest: 'Edit Approval Request',
    softphoneHelpTitle: 'Install Softphone Extension',
    softphoneHelpDescriptionMain:
      'For enhanced call experience, it is recommended to install the CXone Softphone Extension from the Chrome Web Store.',
    softphoneHelpDescriptionSub: 'Click here for details',
    softphoneDonotRemind: 'Do Not Remind Me',
    softphoneRemindMe: 'Remind Me Later',
    sendMessage: 'Send Message',
    shared: 'Shared',
    retweeted: 'Re-Tweeted',
    customWorkspace: 'Custom Workspace',
    Reschedule: 'Reschedule',
    Proceed: 'Proceed',
    rescheduleCommitment: 'Reschedule Commitment',
    interactionRouting: 'Interaction Routing',
    calls: 'Calls',
    caseCustomFieldSaved: 'Your Changes has been saved.',
    caseCustomFieldNotSaved: 'Changes did not save. Try Again',
    googleBusinessMessage: 'Google Business Message',
    approvalDenied: 'Message Denied',
    refuseApprovalError: 'unable to deny approval',
    ApproveDraftMessageError: 'Unable to approve the draft message',
    updateDraftMessageError: 'Unable to update the draft message',
    standardAddressBookHeading: 'Standard Address Book',
    changeStatusTo: 'Change Status To',
    change: 'Change',
    location: 'Location',
    editStatus: 'Edit Status',
    changeStatus: 'Change Status',
    assign: 'Assign',
    export: 'Export',
    exportFormat: 'Export Format',
    assignTo: 'Assign To',
    assignToMe: 'Assign to Me',
    assignToOthers: 'Assign to Others',
    unknown: 'Unknown',
    fontSize: 'Font Size',
    fontFamily: 'Font Family',
    black: 'Black',
    pickledBluewood: 'Pickled bluewood',
    osloGray: 'Oslo gray',
    pewter: 'Pewter',
    zumthor: 'Zumthor',
    athensGray: 'Athens gray',
    matisse: 'Matisse',
    vividViolet: 'Vivid violet',
    goldenGateBridge: 'Golden gate bridge',
    zest: 'Zest',
    elfGreen: 'Elf green',
    bleuDeFrance: 'Bleu de France',
    richLilac: 'Rich lilac',
    cgRed: 'Cg red',
    jonquil: 'Jonquil',
    ufoGreen: 'Ufo green',
    coralCandy: 'Coral candy',
    tropicalBlue: 'Tropical blue',
    frenchLilac: 'French lilac',
    astra: 'Astra',
    aeroBlue: 'Aero blue',
    txtExsmall: 'Extra Small',
    txtSmall: 'Small',
    txtRegular: 'Regular',
    txtLarge: 'Large',
    txtExlarge: 'Extra Large',
    emailValidationMessage: 'Enter valid Email',
    incomingInteraction: 'Incoming Interaction',
    liveInteractionHasEnded: 'Live Interaction has ended',
    newInteractionResponse: 'New Interaction response',
    contactID: 'Contact ID',
    ani: 'ANI',
    returnToAgentView: 'Return to Agent View',
    openInNewTab: 'Open in New Tab',
    viewingInBrowserMessage: 'You are viewing this page in your web browser',
    clickHere: 'Click Here',
    viewInBrowser: 'to view in your Browser',
    viewInAgentApp: 'to view in the agent App',
    whatsappNotificationOnDraftScreen:
      'WhatsApp communication is limited to Quick Replies until the customer responds',
    deleteDraftMessageError: 'Unable to delete the draft message',
    voiceLimit:
      'The no of phone and voicemail contacts that can be simultaneously handled',
    digitalLimit:
      'The no of digital contacts that can be simultaneously handled',
    initiateWhatsappContactError: 'Unable to initiate Whatsapp contact',
    sendMessageSuccess: 'Message sent successfully',
    msgTemplates: 'Message Templates',
    contact: 'contact',
    channelDetails: 'Channel Details',
    none: 'None',
    noContactInfo: 'No Contact Info',
    ring1: 'Ring 1',
    ring2: 'Ring 2',
    ring3: 'Ring 3',
    yesterday: 'YesterDay',
    custom: 'Custom',
    TwentyFourHourTime: '24 Hour Time',
    panelOpenInBrowser: 'Panel Open in Browser: General',
    panelOpenInBrowserPageActionOnly: 'Panel Open in Browser: Page Action Only',
    keyboard: 'Keyboard',
    last24hours: 'Last 24 hours',
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
    segments: 'Segments',
    shift: 'SHIFT',
    play: 'play',
    public: 'Public',
    reqApprovalMessageError: 'Unable to request for message approval: {x}',
    requestApproval: 'Request Approval',
    whatsAppOutboundAgentNotification:
      'Your message has been sent. You will be able to reply once the client has responded.',
    companyInformation: 'Company Information',
    approve: 'Approve',
    deny: 'Deny',
    recentlyUsed: 'Recently Used',
    hasalreadybeenadded: 'has already been added',
    isnotavalidemailaddress: 'is not a valid email address',
    textDirectionltr: 'Left to Right Text Direction',
    textDirectionrtl: 'Right to Left Text Direction',
    information: 'Information',
    unhandledExceptionError:
      'An unexpected error has occured. Please reload the application.',
    reloadAppBtn: 'Reload',
    disableTransferMessage:
      'Transfer is not allowed at this point in time. Please inititate a new conversation.',
    noOBSkillAssigned: 'No outbound skills are assigned to the agent',
    addElevation: 'Add Elevation',
    qReplySent: 'Quick Reply Sent',
    waitingOnHoldX: 'Waiting on Hold',
    allCodes: 'All codes',
    reports: 'Reports',
    customIzeToolBar: 'Customize ToolBar',
    addCommitment: 'Add a commitment',
    inQueue: 'IN QUEUE',
    agentStates: 'AGENT STATES',
    noAssignedSkills: 'No Assigned Skills',
    noSkillsAssigned: 'No Skills Assigned',
    contactsInQueue: 'CONTACTS IN QUEUE',
    agentSkills: 'Agent Skills',
    AssignedSkills: 'Assigned Skills',
    workitem: 'WorkItem',
    ssoLogin: 'Sign In Using SSO',
    lastUpdated: 'Last Updated',
    customerName: 'Customer Name',
    customize: 'Customize',
    greeting: 'Hi',
    copilotIntroduction:
      'Copilot provides insights and answers that power exceptional experiences.',
    howCanIHelp: 'How can I help?',
    intents: 'Intents',
    enterIntents: 'Enter Intents',
    enterOutcomes: 'Enter Outcomes',
    enterActions: 'Enter Actions',
    enterEntities: 'Enter Entities',
    actions: 'Actions',
    entities: 'Entities',
    coPilot: 'Copilot',
    InboundVoice: 'Inbound Voice',
    InboundVideoCall: 'Inbound Video Call',
    InboundVoiceMail: 'Inbound VoiceMail',
    ZenDesk: 'ZenDesk',
    CRM: 'CRM',
    X: 'X',
    applications: 'Applications',
    admin: 'Admin',
    supervisor: 'Supervisor',
    GENERAL: 'GENERAL',
    OMNICHANNELROUTING: 'OMNICHANNEL ROUTING',
    ACD: 'ACD',
    CXoneAgent: 'CXone Agent',
    Patron: 'Patron',
    DATAANALYTICS: 'DATA & ANALYTICS',
    Analytics: 'Analytics',
    Reporting: 'Reporting',
    AUTOMATION: 'AUTOMATION',
    WFI: 'WFI',
    Meeting: 'Meeting',
    Lunch: 'Lunch',
    Client: 'Client',
    PerformanceReview: 'Performance Review',
    DataEntry: 'Data Entry',
    WorkingOB: 'Working-OB',
    Research: 'Research',
    Coaching: 'Coaching',
    Offsite: 'Offsite',
    Training: 'Training',
    HR: 'HR',
    Break: 'Break',
    sort: 'Sort',
    notificationBadge: 'Notification Badge',
    refresh: 'Refresh',
    expand: 'Expand',
    collapse: 'Collapse',
    sortBy: 'Sort By',
    createdDate: 'Created Date',
    lastVisited: 'Last Visited',
    privateChat: 'Private Chat',
    sendTranscript: 'Send Transcript',
    openInNewBrowserWindow: 'Open in new browser window',
    inviteToCobrowsing: 'Invite to Cobrowsing',
    chatWith: 'Chat with',
    note: 'Note',
    digital: 'Digital',
    coBrowse: 'CO-BROWSE',
    coBrowseWithAgent:
      'We have prepared a co-browsing session for you. Click below to co-browse with our agent.',
    joinAgent: 'Join Agent',
    coBrwosingSessionEnd: 'Your co-browsing session ended at',
    coBrowseSessionInProgress: 'Co-browsing session in progress',
    endSession: 'End Session',
    selectItem: 'Select Item',
    travelReservation: 'Travel Reservations',
    yes: 'Yes',
    no: 'No',
    autosummaryCompleted: 'Autosummary Completed',
    generatingSummary: 'Generating Summary',
    summaryGenerationMsg: 'You will be able to edit notes once it is generated',
    markAllAs: 'Mark All As',
    insertResponse: 'Insert Response',
    sendResponse: 'Send Response',
    dislikeResponse: 'Dislike Response',
    likeResponse: 'Like Response',
    interactionSearch: 'Interaction Search',
    conversationTopics: 'Conversation Topics',
    copilotAlert: 'Copilot Alert',
    agentPraise: 'Agent Praise',
    copilotInsight: 'Copilot Insight',
    taskAssist: 'Task Assist',
    completedByTaskAssist: 'Completed by Task Assist',
    searchTopic: 'Search Topic',
    removeTopic: 'Remove Topic',
    newSkills: 'New Skills',
    contactSettings: 'CONTACT SETTINGS',
    acdSkills: 'ACD Skills',
    Campaigns: 'Campaigns',
    Dispositions: 'Dispositions',
    PointsofContact: 'Points of Contact',
    EmailDomains: 'Email Domains',
    SMSBranding: 'SMS Branding',
    SMSRegistration: 'SMS Registration',
    HoursofOperation: 'Hours of Operation',
    ChatProfile: 'Chat Profile',
    Tags: 'Tags',
    OUTBOUND: 'OUTBOUND',
    SkillControl: 'Skill Control',
    SkillChannelSettings: 'Skill Channel Settings',
    MessageTemplates: 'Message Templates',
    LISTS: 'LISTS',
    Calling: 'Calling',
    CallSuppression: 'Call Suppression',
    DoNotCall: 'Do Not Call',
    CustomDataDefinitions: 'Custom Data Definitions',
    ProcessQueue: 'Process Queue',
    ACDSETTINGS: 'ACD SETTINGS',
    UnavailableCodes: 'Unavailable Codes',
    Stations: 'Stations',
    AddressBooks: 'Address Books',
    StationProfiles: 'Station Profiles',
    QuickReplies: 'Quick Replies',
    AgentPatterns: 'Agent Patterns',
    Locations: 'Locations',
    ACDCONFIGURATION: 'ACD CONFIGURATION',
    BusinessUnits: 'Business Units',
    DatabaseConnectors: 'Database Connectors',
    SUPPORT: 'SUPPORT',
    AgentMessaging: 'Agent Messaging',
    AgentIssues: 'Agent Issues',
    BrowseACDFiles: 'Browse ACD Files',
    DFO: 'DFO',
    SLA: 'SLA',
    hoursofOperation: 'Hours of Operation',
    CustomFields: 'Custom Fields',
    Routing: 'Routing',
    RoutingQueues: 'Routing Queues',
    BringYourOwnChannel: 'Bring Your Own Channel',
    Forms: 'Forms',
    SatisfactionSurveys: 'Satisfaction Surveys',
    Typeareplyhere: 'Type a reply here',
    changePassword: 'Change Password',
    supportDownloads: 'Support & Downloads',
    contactus: 'Contact-Us',
    overview: 'Overview',
    details: 'Details',
    interactions: 'Interactions',
    externalData: 'External Data',
    tickets: 'Tickets',
    FULLNAME: 'FULL NAME',
    CUSTOMERSINCE: 'CUSTOMER SINCE',
    ACCOUNTNUMBER: 'ACCOUNT NUMBER',
    SALUTATION: 'SALUTATION',
    TITLE: 'TITLE',
    BALANCE: 'BALANCE',
    NEXTPAYMENT: 'NEXT PAYMENT',
    ACCOUNT: 'ACCOUNT #',
    ACCOUNTTYPE: 'ACCOUNT TYPE',
    ACCOUNTLEVEL: 'ACCOUNT LEVEL',
    DATEOFBIRTH: 'DATE OF BIRTH',
    ADDRESS: 'ADDRESS',
    PREFERREDCONTACTMETHOD: 'PREFERRED CONTACT METHOD',
    LATESTINTERACTIONSUMMARY: 'LATEST INTERACTION SUMMARY',
    LATESTNOTES: 'LATEST NOTES',
    PRIMARYRESIDENCE: 'PRIMARY RESIDENCE',
    BILLINGADDRESS: 'BILLING ADDRESS',
    OTHERS: 'OTHERS',
    GUARANTOR: 'GUARANTOR',
    GUARANTORLASTNAME: 'GUARANTOR LAST NAME',
    GUARANTORFIRSTNAME: 'GUARANTOR FIRST NAME',
    GuarantorSameAsContact: 'Guarantor same as contact',
    FIRSTNAME: 'FIRST NAME',
    LASTNAME: 'LAST NAME',
    DEPARTMENT: 'DEPARTMENT',
    CONTACTTOSPEAK: 'CONTACT TO SPEAK',
    CONTACTGROUP: 'CONTACT GROUP',
    AGENT: 'AGENT',
    AGENTTEAM: 'AGENT TEAM',
    AddAddress: 'Add Address +',
    BillingAddresssameasPrimaryAddress:
      'Billing Address same as Primary Address',
    ADDRESS1: 'ADDRESS 1',
    ADDRESS2: 'ADDRESS 2',
    CITY: 'CITY',
    STATE: 'STATE',
    ZIPCODE: 'ZIP CODE',
    COUNTRY: 'COUNTRY',
    Addressdetailssavedsuccessfully: 'Address details saved successfully',
    Generaldetailssavedsuccessfully: 'General details saved successfully',
    Othersdetailssavedsuccessfully: 'Others details saved successfully',
    cases: 'Cases',
    threads: 'Threads',
    customers: 'Customers',
    filters: 'Filters',
    columns: 'Columns',
    searchcontent: 'Search Content',
    type: 'Type',
    addActivity: 'Add Activity',
    or: 'Or',
    productivity: 'Productivity',
    performance: 'Performance',
    dailerPending: 'Dialer Pending',
    afterCallWork: 'After Call Work',
    agentState: 'Agent State',
    rowsPerPage: 'Rows per page',
    SelectDateRange: 'Select Date Range',
    Personal: 'Personal',
    team: 'Team',
    callType: 'Call Type',
    you: 'You',
    sales: 'Sales',
    customerSupport: 'Customer Support',
    followUp: 'Follow Up',
    escalations: 'Escalations',
    VoiceMail_1: 'VoiceMail 1',
    VoiceMail_2: 'VoiceMail 2',
    customerIsUnhappy: 'Customer is unhappy',
    cannotFindLuggage: "Can't find luggage",
    wantsToChangeFlight: 'Wants to change flight',
    viewWebinars: 'View Webinars',
    CustomerSentimentisNeutral: 'Customer Sentiment is Neutral',
    CustomerSentimentisPositive: 'Customer Sentiment is Positive',
    CustomerSentimentisNegative: 'Customer Sentiment is Negative',
    CopilotAlert: 'Copilot Alert',
    CopilotInsight: 'Copilot Insight',
    AgentPraise: 'Agent Praise',
    showSimulatorButton: 'Show Simulator Button',
    openCalender: 'Open Calender',
    showCustomWorkSpace: 'Show Custom WorkSpace',
    openCRM: 'Open CRM',
    showPartnerAccessButton: 'Show Partner Access Button',
    serviceBot: 'Service Bot',
    date: 'Date',
    Agent: 'Agent',
    Transcription: 'Transcription',
    endOfTranscription: 'End of Transcription',
    campaign: 'Campaign',
    start: 'Start',
    autoSummary: 'Auto Summary',
    selectDateRange: 'Select Date Range',
    customDateRange: 'Custom Date Range',
    lastWeek: 'Last Week (7 days)',
    lastMonth: 'Last Month (30 days)',
    last90Days: 'Last 90 Days',
    startOfConversation: 'Start of Conversation',
    workItem: 'WorkItem',
    meeting: 'MEEETING',
    break: 'BREAK',
    itLooksLike: 'It looks like',
    wouldLikeTo: 'would like to',
    webChat: 'Web Chat',
    custService: 'Cust. Service',
    custServiceRequest: 'Cust. Service Request',

    // consumer app space notes tab

    add_note: 'Add Note',
    note_title: 'Title',

    // consumer app space external data tab
    loyalty_info: 'Loyalty Info',
    gold_elite: 'GOLD ELITE #132192693',
    recent_trips: 'RECENT TRIPS',
    upcoming_trips: 'UPCOMING TRIPS',
    marriott_dallas: 'Marriott Dallas',
    courtyard_miami: 'Courtyard Miami',
    marriott_hawaii: 'Marriott Hawaii',
    marriott_florida: 'Marriott Florida',
    points: '75,860 POINTS',
    confirmation: 'Confirmation',
    sep_date: 'Sep 1-5, 2023',
    aug_date: 'Aug 10-15, 2023',
    jul_date: 'Jul 13-16, 2023',
    case: 'Case',
    current_record: 'CURRENT RECORD',
    related_record: 'RELATED RECORD',
    servicenow_current_record_details:
      'Customer called in about their hotel reservation to see if they were eligible for a free upgrade.',
    servicenow_related_record_details:
      'Customer called in about their hotel reservation to add valet parking.',
    low_status: '4 - Low',
    priority: 'Priority',

    high: 'High',
    medium: 'Medium',
    currentMonth: 'Current Month',
    previousMonth: 'Previous Month',
    currentQuarter: 'Current Quarter',
    previousQuarter: 'Previous Quarter',
    previous12Month: 'Previous 12 Month',
    last90days: 'Last 90 Days',
    last60days: 'Last 60 Days',
    low: 'Low',
    onboarding_request_service: 'Onboarding - Request Service',
    airline_customer_service: 'Airline Customer Service',

    // Agent Messages Translations
    create: 'Create',
    add_member: 'Add Member',
    new_group_name: 'New Group Name',
    groups: 'Groups',
    direct_messages: 'Direct Messages',
    search_in_chat: 'Search in Chat',
    add_remove_member: 'Add/Remove Member',
    edit_group_name: 'Edit Group Name',
    leave_group: 'Leave Group',
    remove_from_favorites: 'Remove from Favorites',
    add_to_favorites: 'Add To Favorites',

    // Adaptive cards translations
    adp_journeySummary: 'Journey Summary',
    adp_internalUseOnly: 'Internal Use Only',
    adp_webLinks: 'Web Links',
    adp_images: 'Images',
    adp_processSteps: 'Process Steps',
    adp_insertArticle: 'Insert Article',
    adp_insertLink: 'Insert Link',
    adp_insertImage: 'Insert Image',
    adp_insertSteps: 'Insert Steps',
    adp_insertStep: 'Insert Step',
    adp_sendArticle: 'Send Article',
    adp_sendLink: 'Send Link',
    adp_sendImage: 'Send Image',
    adp_sendSteps: 'Send Steps',
    adp_sendStep: 'Send Step',
    adp_openLink: 'Open Link',
    adp_expandImage: 'Expand Image',
    adp_positiveSentiment: 'Customer Sentiment is Positive',
    adp_negativeSentiment: 'Customer Sentiment is Negative',
    adp_neutralPositiveSentiment: 'Customer Sentiment is Neutral',
    adp_neutralNegativeSentiment: 'Customer Sentiment is NeutralNegative',
    adp_transferSummary: 'Transfer Summary',
    adp_generateEmailResponse: 'Generate Email Response',
    adp_replyIsGenerating: 'Reply is generating',
    adp_generate: 'Generate',
    adp_replyGenerated: 'Reply Generated',
    adp_noAutomaticSuggestionFound: 'No automatic suggestions found',
    adp_emailGeneratorIsCurrentlyDown: 'Email Generator is currently down',
    adp_possibleComplianceRisk: 'Possible Compliance Risk',
    adp_salesOffers: 'Sales Offers',
    adp_features: 'Features',
    adp_pricing: 'Pricing',
    adp_justification: 'Justification',
    adp_last: 'LAST',
    adp_interactions: 'INTERACTIONS',
    adp_closed: 'CLOSED',
    adp_open: 'OPEN',
    adp_rateYourCopilotExperience: 'Rate your Copilot experience.',
    adp_helpUsToMakeYourExperienceBetterByLettingUsKnowWhichCardsYouFoundHelpful:
      'Help us to make your experience better by letting us know which cards you found helpful.',
    adp_searchTopic: 'Search Topic',
    adp_removeTopic: 'Remove Topic',
    adp_insertCompliance: 'Insert Compliance',
    adp_sendCompliance: 'Send Compliance',
    adp_likeArticle: 'Like Article',
    adp_likedArticle: 'Liked Article',
    adp_dislikeArticle: 'Dislike Article',
    adp_dislikedArticle: 'Disliked Article',
    adp_insertSalesOffers: 'Insert SalesOffers',
    adp_sendSalesOffers: 'Send SalesOffers',
    adp_autoRun: 'Auto Run',
    adp_Open: 'Open',
    adp_Close: 'Close',
    adp_sendQuestion: 'Send Question',
    adp_submit: 'Submit',
    adp_shareWithClient: 'Share with client',
    adp_save: 'Save',
    adp_selectTopicMessage:
      'Select at least one topic to generate an email response',
    adp_responseTopics: 'Response Topics Identifided',
    adp_addTopic: 'Add Topics ',
    autopilotTransferSummary: 'Autopilot Transfer Summary',
    agentTransferSummary: 'Agent Transfer Summary',
    adp_enterNewTopic: 'Enter New Topic',
    adp_noSuggestionFoundDescription:
      'Ask Copilot questions to help write a response.',
    adp_emailGeneratorDownDescription: 'Try regenating responses.',
    adp_replyGeneratedDescription:
      'An email message has been generated and inserted into the reply field for your review.',
    adp_generateEmailDescription:
      'Copilot can generate a response to this email for you to review and change. How would you like this email to be generated?',
    adp_replyGeneratingDescription:
      'Wait a few seconds, Copilot is working on your generated response.',
    adp_responseLength: 'Select response length',
    adp_responseLengthLong: 'Long',
    adp_responseLengthShort: 'Short',

    copilotEmailGenerationPlaceholderText:
      'Copilot is generating a reply for you.',
    copilotEmailUpdatingPlaceholderText:
      'Copilot is updating the reply for you.',
    insertTable: 'Insert Table',
    rows: 'Rows',
    noOfRowsColumns: 'Value between 1-50',
    confirm: 'Confirm',

    // OneBank
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onebank_how_can_i_help_you_today:
      'Hi, my name is Julie.  Thank you for reaching out to OneBank.  How can I help you today?',
    hi_there_i_have_a_few_things_i_wanted_to_find_out_about_today_i_hope_you_can_help_me:
      'Hi there, I have a few things I wanted to find out about today, I hope you can help me',
    thank_you_i_would_like_to_explore_setting_up_a_trust_can_you_tell_me_about_some_of_the_benefits_and_drawbacks_i_should_consider:
      'Thank you.  I would like to explore setting up a trust. Can you tell me about some of the benefits and drawbacks I should consider?',
    are_there_different_types_of_trusts: 'Are there different types of trusts?',
    thank_you_it_sounds_like_i_need_to_do_some_more_research:
      'Thank you. It sounds like I need to do some more research',
    the_next_thing_id_like_to_discuss_is_helping_pay_for_my_grandsons_education_ive_been_considering_a_529_plan_can_you_tell_me_about_529_plans:
      "The next thing I'd like to discuss is helping pay for my grandson's education.  I've been considering a 529 plan.  Can you tell me about 529 plans?",
    how_are_529_plans_typically_funded: 'How are 529 plans typically funded?',
    i_think_id_want_to_fund_it_through_a_payroll_deduction_how_would_i_set_that_up:
      "I think I'd want to fund it through a payroll deduction.  How would I set that up?",
    i_can_give_you_an_overview_of_the_process_but_you_would_have_to_set_up_the_529_account_before_you_can_start_funding_it:
      'I can give you an overview of the process but you would have to set up the 529 account before you can start funding it.',
    yes_thank_you_for_that_information: 'Yes, thank you for that information.',
    ok_the_last_thing_i_want_to_talk_about_is_mortgages_id_like_to_help_my_granddaughter_buy_her_first_home_but_i_want_her_to_educate_herself_and_select_the_right_type_of_mortgage_do_you_have_any_tools_or_information_for_firsttime_homebuyers:
      "Ok.  The last thing I want to talk about is mortgages.  I'd like to help my grand-daughter buy her first home, but I want her to educate herself and select the right type of mortgage.  Do you have any tools or information for first-time homebuyers?",
    that_is_great_thank_you: 'That is great.  Thank you!',
    is_there_is_anything_else_i_can_assist_you_with_today:
      'Is there is anything else I can assist you with today?',
    no_that_would_be_it_you_have_been_great_thank_you_so_much_for_your_help:
      'No that would be it, you have been great!  Thank you so much for your help!',
    you_are_very_welcome_thank_you_for_contacting_onebank_and_for_your_business:
      'You are very welcome, thank you for contacting OneBank and for your business!',

    // OneBank_mortgage
    hello_peter_this_is_emily_thank_you_for_reaching_out_to_onebank_i_see_you_indicated_your_interest_in_mortgages_what_can_i_help_you_with_today:
      'Hello Peter, this is Emily. Thank you for reaching out to OneBank. I see you indicated your interest in mortgages. What can I help you with today?',
    hey_yes_this_is_my_first_home_so_im_trying_to_learn_the_basics:
      "Hey - yes this is my first home so I'm trying to learn the basics",
    are_there_different_kinds_of_mortgages:
      'Are there different kinds of mortgages?',
    whats_the_difference_between_fixed_and_adjustable_mortgages:
      "What's the difference between fixed and adjustable mortgages?",
    thanks: 'Thanks',
    what_is_the_process_to_get_preapproved:
      'What is the process to get pre-approved?',
    i_can_help_you_begin_the_preapproval_process_now_if_youd_like:
      "I can help you begin the pre-approval process now if you'd like",
    thx_i_just_wanted_a_little_info_today:
      'Thx I just wanted a little info today',
    ill_digest_and_reach_back_out_in_a_few_days:
      "I'll digest and reach back out in a few days",
    i_can_also_schedule_you_on_the_day_and_time_of_your_choosing:
      'I can also schedule you on the day and time of your choosing?',
    yeah_that_sounds_good: 'Yeah that sounds good',
    your_appointment_is_confirmed_do_you_have_any_other_questions_i_can_address_today:
      'Your appointment is confirmed. Do you have any other questions I can address today?',
    im_all_set_you_have_been_super_helpful_thank_you:
      "I'm all set. You have been super helpful! Thank you",

    // Insurance
    hi_my_name_is_oscar_thank_you_for_reaching_out_to_oneinsurance_how_can_i_help_you_today:
      'Hi, my name is Oscar.  Thank you for reaching out to OneInsurance.  How can I help you today?',
    hi_there_im_shopping_around_for_insurance_and_i_have_a_few_questions_im_hoping_you_can_help_me_with:
      'Hi there, I’m shopping around for insurance and I have a few questions I’m hoping you can help me with.',
    thank_you_lets_start_with_the_home_do_your_home_owners_policies_include_loss_of_use_coverage:
      "Thank you.  Let’s start with the home.  Do your home owner's policies include loss of use coverage?",
    does_home_insurance_cover_flooding: 'Does home insurance cover flooding?',
    what_does_flood_insurance_cover: 'What does flood insurance cover?',
    ok_thanks_now_lets_move_on_to_auto_do_your_auto_policies_include_accident_forgiveness:
      'Ok, thanks, now let’s move on to Auto.  Do your auto policies include accident forgiveness?',
    can_you_talk_me_through_the_claims_process:
      'Can you talk me through the claims process?',
    thank_you_that_was_helpful_but_what_if_my_repairs_cost_more_than_your_estimate:
      'Thank you, that was helpful.   But what if my repairs cost more than your estimate?',
    ok_thank_you_im_starting_to_explore_getting_disability_income_insurance_i_live_in_a_single_income_household_how_does_disability_income_insurance_work:
      'Ok, thank you. I’m starting to explore getting Disability Income Insurance. I live in a single income household. How does Disability Income Insurance work?',
    what_does_disability_income_insurance_cost:
      'What does disability income insurance cost?',
    how_would_i_go_about_getting_a_quote_from_you:
      'How would I go about getting a quote from you?',
    i_could_schedule_a_time_for_an_insurance_agent_to_call_you_to_gather_this_information_and_provide_you_with_a_quote:
      'I could schedule a time for an insurance agent to call you to gather this information and provide you with a quote?',
    that_would_be_great_thank_you: 'That would be great, thank you!',
    is_there_anything_else_i_can_help_you_with_today:
      'Is there anything else I can help you with today?',
    you_are_very_welcome_thank_you_for_contacting_onetelecom_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTelecom and have a great day!',

    // OneUniversity
    hi_there_my_name_is_anthony_thank_you_for_reaching_out_to_one_education_university_how_can_i_help_you_today:
      'Hi there, my name is Anthony.  Thank you for reaching out to One Education University.  How can I help you today?',
    yes_im_interested_in_your_bs_in_criminal_justice_program_will_this_program_help_me_prepare_for_licensure_in_the_state_of_minnesota:
      "Yes.  I'm interested in your BS in Criminal Justice program.  Will this program help me prepare for licensure in the state of Minnesota?",
    ok_i_guess_thats_good_to_know_ill_have_to_take_that_into_consideration:
      "Ok, I guess that's good to know.  I'll have to take that into consideration.",
    can_i_transfer_credits_from_another_institution:
      'Can I transfer credits from another institution?',
    whats_the_maximum_number_of_credits_i_can_transfer:
      "What's the maximum number of credits I can transfer?",
    what_are_the_tuition_costs_for_the_bs_in_criminal_justice_program:
      'What are the tuition costs for the BS in criminal justice program?',
    can_you_tell_me_about_your_application_process:
      'Can you tell me about your application process?',
    great_thank_you_for_all_the_information_i_have_a_lot_to_think_about:
      'Great! Thank you for all the information.  I have a lot to think about',
    would_you_like_to_speak_with_an_admissions_counselor_they_can_answer_any_further_questions_you_might_have:
      'Would you like to speak with an admissions counselor? They can answer any further questions you might have.',
    that_would_be_great: 'That would be great!',
    awesome_thank_you: 'Awesome! Thank you!',
    no_thats_it_thank_you_again_for_all_your_help_today:
      "No, that's it.  Thank you again for all your help today!",

    // Telecom
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onetelecom_how_can_i_help_you_today:
      'Hi, my name is Julie. Thank you for reaching out to OneTelecom. How can I help you today?',
    hi_there_i_have_a_few_questions_today_i_hope_you_can_help_me:
      'Hi there, I have a few questions today, I hope you can help me',
    thank_you_i_just_received_my_first_bill_and_it_was_higher_than_i_expected_and_im_not_sure_why:
      "Thank you. I just received my first bill and it was higher than I expected and I'm not sure why.",
    ok_that_makes_sense_thank_you: 'Ok, that makes sense. Thank you.',
    can_you_help_me_sign_up_for_autopay: 'Can you help me sign up for AutoPay?',
    yes_thank_you_so_much: 'Yes, thank you so much!',
    im_going_to_start_working_from_home_and_i_wonder_if_my_internet_is_fast_enough:
      "I'm going to start working from home and I wonder if my internet is fast enough.",
    how_can_i_do_a_speed_test_to_see_what_speed_im_actually_getting:
      "How can I do a speed test to see what speed I'm actually getting?",
    ok_give_me_a_minute_to_do_that_please:
      'Ok, give me a minute to do that please.',
    im_getting_closer_to_40_mbps_so_i_guess_im_all_set_with_my_internet:
      "I'm getting closer to 40 Mbps, so I guess I'm all set with my internet.",
    im_looking_to_add_tv_service_through_you_can_you_tell_me_about_your_plans:
      "I'm looking to add TV service through you. Can you tell me about your plans?",
    i_think_id_like_to_go_ahead_and_sign_up_for_the_popular_package_can_you_help_me_with_that:
      "I think I'd like to go ahead and sign up for the popular package. Can you help me with that?",
    absolutely_lets_get_you_signed_up: "Absolutely! Let's get you signed up!",
    is_there_anything_else_i_can_assist_you_with_today:
      'Is there anything else I can assist you with today?',
    you_are_very_welcome_thank_you_for_contacting_one_telecom_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTelecom and have a great day!',

    // OneHealth
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onehealth_how_can_i_help_you_today:
      'Hi, my name is Julie.  Thank you for reaching out to oneHealth.  How can I help you today?',
    hi_i_just_signed_up_for_the_bronze_60_ppo_individual_plan_and_i_have_a_few_questions:
      'Hi.  I just signed up for the Bronze 60 PPO individual plan and I have a few questions.',
    thank_you_can_you_remind_me_what_the_monthly_cost_is_for_the_plan:
      'Thank you.  Can you remind me what the monthly cost is for the plan?',
    ok_thank_you_and_can_you_tell_me_about_the_broze_60_ppo_plan_details_and_coverage:
      'Ok, thank you.  And can you tell me about the Bronze 60 PPO plan details and coverage?',
    now_what_exactly_is_a_ppo: 'Now what exactly is a PPO?',
    do_i_need_a_referral_to_see_a_specialist_with_the_bronze_ppo_plan:
      'Do I need a referral to see a specialist with the Bronze PPO plan?',
    ok_thats_great_im_pregnant_and_im_going_to_be_having_a_baby_in_about_8_months_do_you_have_any_estimate_of_what_it_will_cost_me_out_of_pocket_to_have_a_baby_with_the_broze_60_ppo_plan:
      "Ok, that's great.  I'm pregnant and I'm going to be having a baby in about 8 months. Do you have any estimate of what it will cost me out of pocket to have a baby with the Bronze 60 PPO plan?",
    thats_very_helpful_thank_you_for_the_information:
      "That's very helpful, thank you for the information.",
    one_last_question_for_you_does_onehealth_offer_any_programs_to_help_members_live_healthy_lives:
      'One last question for you.  Does OneHealth offer any programs to help members live healthy lives?',
    thats_great_thank_you: "That's great.  Thank you!",
    i_guess_the_last_thing_i_need_help_with_is_finding_a_new_obgyn_and_making_an_appointment_can_you_help_me_with_that:
      'I guess the last thing I need help with is finding a new OBGYN and making an appointment.  Can you help me with that?',
    i_would_be_glad_to_help_you_with_that:
      'I would be glad to help you with that!',
    no_that_would_be_it_youve_been_great_thank_you_so_much_for_your_help:
      "No, that would be it, you've been great! Thank you so much for your help.",
    you_are_so_very_welcome_thank_you_for_reaching_out_to_onehealth_and_i_hope_you_have_a_great_appointment_with_your_new_obgyn:
      'You are so very welcome! Thank you for reaching out to OneHealth and I hope you have a great appointment with your new OBGYN.',

    // OneTravel
    hi_my_name_is_oscar_thank_you_for_reaching_out_to_onetravel_airlines_how_can_i_help_you_today:
      'Hi, my name is Oscar. Thank you for reaching out to OneTravel Airlines. How can I help you today?',
    hi_there_i_booked_my_first_flight_on_your_airline_a_few_days_ago_and_i_have_a_few_things_im_hoping_you_can_help_me_with:
      "Hi there, I booked my first flight on your airline a few days ago and I have a few things I'm hoping you can help me with.",
    thank_you_how_do_i_change_my_seat: 'Thank you. How do I change my seat?',
    i_had_surgery_on_my_left_leg_recently_and_im_still_moving_around_a_bit_slowly_can_i_add_special_assistance_to_my_reservation:
      "I had surgery on my left leg recently and I'm still moving around a bit slowly. Can I add special assistance to my reservation?",
    also_what_do_i_need_to_do_to_travel_with_my_service_animal:
      'Also, what do I need to do to travel with my service animal?',
    i_forgot_to_add_my_ktn_to_my_reservation_how_can_i_me_add_it:
      'I forgot to add my KTN to my reservation. How can I add it?',
    and_when_can_i_check_into_my_flight: 'And when can I check into my flight?',
    theres_a_possibility_that_i_may_need_to_change_my_travel_dates_how_would_i_change_my_flight:
      "There's a possibility that I may need to change my travel dates. How would I change my flight?",
    i_didnt_realize_you_had_an_app_ill_go_ahead_and_download_it:
      "I didn't realize you had an App. I'll go ahead and download it.",
    one_last_question_since_i_have_you_i_have_a_15_year_old_granddaughter_is_she_old_enough_to_take_a_domestic_flight_by_herself:
      'One last question since I have you. I have a 15 year old granddaughter. Is she old enough to take a domestic flight by herself?',
    thats_good_to_know_thank_you_so_much_for_your_help_today:
      "That's good to know. Thank you so much for your help today!",
    no_that_would_be_it_youve_have_been_great:
      "No that would be it, you've been great!",
    you_are_very_welcome_thank_you_for_contacting_onetravel_airlines_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTravel Airlines and have a great day!',

    // Public Sector
    hi_my_name_is_isabel_thank_you_for_reaching_out_to_state_i_see_that_you_would_like_some_help_completing_an_application_is_that_correct:
      'Hi, my name is Isabel. Thank you for reaching out to State. I see that you would like some help completing an application. Is that correct?',
    yes_please_i_would_appreciate_help_completing_my_application_for_the_child_care_payment_assistance_program:
      'Yes please, I would appreciate help completing my application for the Child Care Payment Assistance Program',
    of_course_thats_why_were_here_to_help_our_residents_when_they_need_it:
      "Of course, that's why we're here, to help our residents when they need it!",
    you_will_need_to_provide_your_personal_information_along_with_financial_employment_and_childcare_information_and_documentation_do_you_have_all_of_that_information_available:
      'You will need to provide your personal information along with financial, employment, and childcare information and documentation. Do you have all of that information available?',
    i_dont_i_didnt_realize_it_would_be_that_involved:
      "I don't. I didn't realize it would be that involved.",
    dont_worry_its_actually_quite_simple_it_just_sounds_like_a_lot_id_be_glad_to_send_you_a_paper_application_in_the_mail_or_schedule_a_time_to_call_you_back:
      "Don't worry, it's actually quite simple, it just sounds like a lot. I'd be glad to send you a paper application in the mail or schedule a time to call you back.",
    if_you_could_send_me_an_application_in_the_mail_that_would_be_great:
      'If you could send me an application in the mail, that would be great!',
    of_course_can_you_please_provide_your_mailing_address:
      'Of course! Can you please provide your mailing address?',
    sure_its_10300_jackson_street_apartment_1013:
      "Sure. It's 10300 Jackson Street, Apartment 1013.",
    ill_get_that_out_in_the_mail_to_you_today_is_there_anything_else_i_can_help_you_with_today:
      "I'll get that out in the mail to you today. Is there anything else I can help you with today?",
    yes_i_understand_the_state_provides_interview_prep_workshops_could_you_help_me_enroll_in_one_of_them:
      'Yes, I understand the state provides interview prep workshops. Could you help me enroll in one of them?',
    absolutely: 'Absolutely!',
    thank_you_so_much: 'Thank you so much!',
    can_you_tell_me_about_the_eap_program:
      'Can you tell me about the EAP program?',
    no_that_would_be_it_youve_been_really_great_thank_you_so_much_for_your_help:
      "No that would be it, you've been really great! Thank you so much for your help!",
    you_are_very_welcome_thank_you_for_contacting_state_and_have_a_nice_day:
      'You are very welcome, thank you for contacting State and have a nice day',

    // Interactions - NextGen1
    hi_connor_i_see_that_you_were_just_on_our_website_looking_at_our_2_year_upgrade_tradein_program_it_looks_like_your_phone_is_just_about_2_years_old_are_you_looking_to_upgrade_it:
      'Hi Connor, I see that you were just on our website looking at our 2-year Upgrade & Trade-in program. It looks like your phone is just about 2 years old, are you looking to upgrade it?',
    im_not_sure_yet: "I'm not sure yet",
    does_nextgen_have_the_phonolo_15: 'Does NextGen have the Phonolo 15?',
    good_to_know: 'Good to know',
    can_you_tell_me_about_the_phonolo_15s_camera:
      "Can you tell me about the Phonolo 15's camera?",
    hey_im_sorry_my_sisters_at_the_door_i_need_to_step_away_i_guess_i_can_go_back_to_your_website_to_chat_with_someone_later:
      "Hey, I'm sorry, my sister's at the door, I need to step away. I guess I can go back to your website to chat with someone later?",
    i_totally_understand_id_be_glad_to_send_you_a_text_message_to_schedule_a_better_time_for_us_to_chat:
      "I totally understand. I'd be glad to send you a text message to schedule a better time for us to chat?",
    yeah_thatd_be_great_thanks: "Yeah, that'd be great! Thanks!",

    // Interactions - NextGen2
    hi_connor_its_good_to_chat_again_is_this_a_better_time_for_you:
      "Hi Connor, it's good to chat again. Is this a better time for you?",
    now_works: 'Now works',
    great_earlier_today_we_were_talking_about_a_potential_phone_upgrade_and_the_new_phonolo_15s_great_camera_features_i_know_that_photography_is_a_hobby_of_yours_its_one_of_mine_too_and_i_promise_you_will_not_be_disappointed:
      "Great! Earlier today we were talking about a potential phone upgrade and the new Phonolo 15's great camera features. I know that Photography is a hobby of yours, it's one of mine too and I promise, you will not be disappointed!",
    _what_other_questions_can_i_answer_for_you:
      'What other questions can I answer for you?',
    how_much_is_the_phonolo_15: 'How much is the Phonolo 15?',
    do_you_have_any_promotions_on_phones:
      'Do you have any promotions on phones?',
    what_tablets_do_you_have: 'What tablets do you have?',
    ive_been_looking_at_the_iron_tablet_:
      "I've been looking at the Iron Tablet ...",
    id_like_to_go_ahead_with_the_promotion_can_you_help_me_with_that:
      "I'd like to go ahead with the promotion. Can you help me with that?",
    is_there_anything_else_i_can_help_you_with_today_connor:
      'Is there anything else I can help you with today Connor?',
    no_youve_been_great_thank_you_for_your_help:
      "No, you've been great. Thank you for your help!",

    // Interactions - NextGen_B_Demo1
    hi_sarah_my_name_is_ellie_thank_you_for_your_home_internet_business_i_understand_that_youre_looking_to_move_5_mobile_lines_to_nextgen_today:
      "Hi Sarah, my name is Ellie. Thank you for your home internet business! I understand that you're looking to move 5 mobile lines to NextGen today?",
    yes_but_i_forgot_to_ask_a_question: 'Yes, but I forgot to ask a question',
    do_you_have_a_family_calling_plan: 'Do you have a family calling plan?',
    _thats_great_and_can_you_tell_me_about_the_phonolo_15s_ai_features:
      "That's great. And can you tell me about the Phonolo 15's AI features?",
    what_if_my_kids_lose_their_device: 'What if my kids lose their device?',
    do_you_offer_insurance_on_phones_and_tablets:
      'Do you offer insurance on phones and tablets?',
    we_do_and_its_the_same_insurance_provider_that_youve_already_used_to_replace_your_router_based_on_the_ratings_you_gave_them_it_seems_like_that_was_a_good_experience_for_you:
      "We do, and it's the same insurance provider that you've already used to replace your router. Based on the ratings you gave them, it seems like that was a good experience for you.",
    i_think_id_like_to_go_ahead_and_port_my_5_mobile_lines:
      "I think I'd like to go ahead and port my 5 mobile lines.",
    thats_great_ill_be_glad_to_help_you_with_that_i_see_that_you_have_those_lines_on_two_carriers_which_is_the_first_carrier:
      "That's great! I'll be glad to help you with that. I see that you have those lines on two carriers? Which is the first carrier?",
    onetelecom: 'OneTelecom',
    and_how_many_lines_do_you_have_with_them:
      'And how many lines do you have with them?',
    three_do_you_need_the_numbers: 'Three. Do you need the numbers?',
    yes_please: 'Yes please',
    theyre_2153690310_2153690970_and_2153690160:
      "They're 215-369-0310, 215-369-0970 and 215-369-0160",
    and_will_you_be_purchasing_the_same_phones_and_tablets_for_those_3_lines:
      'And will you be purchasing the same phones and tablets for those 3 lines?',
    yes_the_phonolo_15_and_iron_tablet: 'Yes, the Phonolo 15 and Iron tablet',
    thank_you_we_can_start_there: 'Thank you, we can start there!',
    thank_you_so_much_for_your_help: 'Thank you so much for your help!',
    ive_heard_youre_going_to_be_offering_free_streaming_can_you_tell_me_more_about_that:
      "I've heard you're going to be offering free streaming? Can you tell me more about that?",
    unfortunately_i_dont_have_any_information_about_free_streaming:
      "Unfortunately, I don't have any information about free streaming...",

    // Interactions - NextGen_B_Demo2
    hi_mr_ellis_my_name_is_paul_thank_you_for_being_a_loyal_mobile_internet_customer_of_ours_how_can_i_help_you_today:
      'Hi Mr. Ellis, my name is Paul. Thank you for being a loyal mobile & internet customer of ours. How can I help you today?',
    you_mentioned_that_possibility_a_while_back_you_work_as_a_video_editor_correct:
      'You mentioned that possibility a while back. You work as a video editor, correct?',
    yeah_thats_right_i_do_a_lot_of_video_conferences_and_video_streaming_what_internet_package_do_you_recommend:
      "Yeah, that's right ... I do a lot of video conferences and video streaming. What internet package do you recommend?",
    how_can_i_do_a_speed_test_to_see_what_speed_im_getting_today:
      "How can I do a speed test to see what speed I'm getting today?",
    im_getting_only_30_mbps: "I'm getting only 30 Mbps",
    it_looks_like_i_need_to_upgrade_my_internet_can_you_help_me_with_that:
      'It looks like I need to upgrade my internet. Can you help me with that?',
    of_course: 'Of course!',
    ive_been_looking_at_upgrading_our_mobile_phones:
      "I've been looking at upgrading our mobile phones.",
    i_can_see_that_you_were_researching_the_new_phonolo_15_about_2_months_ago_its_a_significant_upgrade_over_the_phonolo_13_you_and_your_wife_currently_have:
      "I can see that you were researching the new Phonolo 15 about 2 months ago. It's a significant upgrade over the Phonolo 13 you and your wife currently have.",
    yes_it_certainly_looks_like_it_the_ai_features_are_intriguing:
      'Yes, it certainly looks like it! The AI features are intriguing.',
    do_you_have_any_promotions_on_phones_right_now:
      'Do you have any promotions on phones right now?',
    im_not_sure_were_interested_in_another_tablet_right_now:
      "I'm not sure we're interested in another tablet right now.",
    do_you_offer_monthly_payment_plans_for_phones:
      'Do you offer monthly payment plans for phones?',
    thats_good_to_know_let_me_talk_to_my_wife_about_it:
      "That's good to know! Let me talk to my wife about it.",
    of_course_is_there_anything_else_i_can_help_you_with_today:
      'Of course! Is there anything else I can help you with today?',
    you_are_very_welcome_have_a_great_day_mr_ellis:
      'You are very welcome, have a great day Mr. Ellis!',
    noWorkspacesAvailable: 'No Workspaces Available',
    simulator: 'Simulator',
    processAutomation: 'Process Automation',
    paTaskAssistant: 'Task Assistant',
    paOpenTaskAssistant: 'Open Task Assistant',
    paSearchTasks: 'Search for an automated task',
    paNoTasksTitle: 'No tasks available',
    paNoTasks: 'No current tasks available for this interaction, check back later',
    paNoMatchingTasks: 'No matching tasks',
    paAnotherTaskRunning: 'Another task is in progress',
    paViewForm: 'View Form',
    paRun: 'Run',
    paBack: 'Back',
    paConfirm: 'Confirm',
    paDismiss: 'Dismiss',
    paClose: 'Close',
    paCollapse: 'Collapse',
    paExpand: 'Expand',
    paTaskInProgress: 'The task is in progress',
    paInProgress: 'In progress',
    paBlocked: 'Waiting for agent input',
    paPaused: 'Paused',
    paCompleted: 'Completed',
    paCancelled: 'Cancelled',
    paPause: 'Pause',
    paResume: 'Resume',
    paEndTask: 'End Task',
    paPausedHint: 'Resume whenever you are ready or end the task below.',
    paRequiresAttention: 'This task requires your attention.',
    paReviewIntro: 'Information is complete, please review before submitting.',
    paCancelledHint: 'The task was ended before it finished.',
    paForAgent: 'Summary',
    paForCustomer: 'Message for the customer',
    paEditMessage: 'Click to edit the message before sending',
    paInsertMessage: 'Insert into reply',
    paSendToCustomer: 'Send to customer',
    paSent: 'Sent'
  },
};
